import { t } from "i18next";

import { JSX, Suspense } from "react";
import { Outlet } from "react-router-dom";

import DetailActorsSection from "@/components/detail/DetailActorsSection";
import DetailDescription from "@/components/detail/DetailDescription.tsx";
import DetailEpisodes from "@/components/detail/DetailEpisodes.tsx";
import DetailHero from "@/components/detail/DetailHero.tsx";
import DetailHeroMobile from "@/components/detail/DetailHeroMobile";
import DetailSimilarMovies from "@/components/detail/DetailSimilarMovies";
import RateAndComments from "@/components/detail/RateAndComments";
import RecommendedMovies from "@/components/detail/RecommendedMovies";
import SectionSkeleton from "@/components/helpers/Section/Section.skeleton";

import { DetailDescriptionSkeleton, DetailHeroSkeleton } from "./DetailDescriptionSkeleton";
import { DetailHeroSkeletonMobile } from "./DetailDescriptionSkeletonMobile";

const DetailPage = (): JSX.Element => {
  return (
    <>
      <Suspense fallback={<DetailHeroSkeleton />}>
        <DetailHero />
      </Suspense>
      <Suspense fallback={<DetailHeroSkeletonMobile />}>
        <DetailHeroMobile />
      </Suspense>
      <Suspense
        fallback={
          <div className="mt-6 h-[300px] w-full  overflow-hidden rounded-[1.875rem] max-lg:mt-3 max-lg:px-4">
            <div className="h-full w-full animate-pulse bg-surface-container-high"></div>
          </div>
        }
      >
        <DetailEpisodes />
      </Suspense>
      <Suspense fallback={<DetailDescriptionSkeleton />}>
        <DetailDescription />
      </Suspense>
      <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={"/"} className="" />}>
        <DetailActorsSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={"/"} className="" />}>
        <RateAndComments />
      </Suspense>
      <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={"/"} className="" />}>
        <DetailSimilarMovies />
      </Suspense>
      <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={"/"} className="" />}>
        <RecommendedMovies />
      </Suspense>
      <Outlet />
    </>
  );
};

export default DetailPage;
